import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import 'bootstrap-icons/font/bootstrap-icons.css';
import InputGroup from 'react-bootstrap/InputGroup'
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Placeholder from 'react-bootstrap/Placeholder';
import { useState } from 'react';
import { GetAccessToken } from "../index";
import { useMsal } from "@azure/msal-react";
import { DisplaySavedMessage } from './DisplaySavedMessage'
import { AddResidentialReturn } from './AddResidentialReturn';
import { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Toast from 'react-bootstrap/Toast';
import "./AddRuralReturn.css";
import Checkbox from "@mui/material/Checkbox";
import { msalConfig } from '../authConfig';
import { useAppConfig } from '../config/AppConfigContext';

export function EditRuralReturn({...props}) {
    const { instance } = useMsal();
    const [message, setMessage] = useState(false);
    const [validated, setValidated] = useState(false);
    const [validationError, setValidationError] = useState(null);
    const [showResidential, setshowResidential] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const handleCloseModalDelete = () => setShowModalDelete(false);
    const [data, setData] = useState(false);
    const [error, setError] = useState(null);
    const [searchResults, setSearchResults] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [isAddressVisible, setAddressIsVisible] = useState(false);
    const [SelectedDateRange, setDateRangeValue] = useState([]);
    const [SelectedCategory, setReturnListCategory] = useState([]);
    const [SelectedReturnStatus, setReturnListStatus] = useState([]);
    const [SelectedReturnSaleMethod, setReturnListSaleMethod] = useState([]);
    const handleClose = () => setShowModal(false);
    const [showToast, setShowToast] = useState(false);
    const [isOrgVisible, setOrgIsVisible] = useState(false);
    const [isOrgsVisible, setOrgsIsVisible] = useState(false);
    const [searchOrgResults, setOrgSearchResults] = useState([]);
    const [searchOrgsResults, setOrgsSearchResults] = useState([]);
    const [isAgencyVisible, setAgencyIsVisible] = useState(false);
    const [searchAgencyResults, setAgencySearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [rural,setrural] = useState({
        /*Primary property info*/
        SaleId: null,
        DbId: null,
        OfficeReinzId: null,
        ReturnType: "Rural",
        SaleIsConjoint: false,
        ConjointOfficeReinzId: null,
        AdminNotes: null,
        ReturnPeriod: (new Date((new Date()).setMonth((new Date()).getMonth()))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth()))).getFullYear(),
        ExternalId: null,
        AddressSearch: null,
        ValRef: null,
        Unit: null,
        Suffix: null,
        StreetNumber:null,
        Street: null,
        Suburb: null,
        PostalCode:0,
        /*Title:"",*/
        CertificateOfTitle: null,
        FreeholdStatus: null,
        Category: null,
        //fields not present on rural form      
        DiseaseStatus: null,
        LifestyleCategory: null,
        LivestockCategory: null,
        Outlook: null,
        RuralCouncil: null,
        /*Rural info*/
        BareLand: false,
        Farmlet: false,
        Contour: null,
        IrrigationType: "None",
        WaterSupply: null,
        LandArea: 0,
        AreaUnit:1,
        Bedrooms: 0,
        Bathrooms: 0,
        Dwellings: 0,
        MainDwelling: null,
        AdditionalDwelling: null,
        Improvements: null,
        Comments: null,
        /*AdditionalComments: null,*/
        Suppressed: false,
        GST: false,
        /*Horticulture fields*/
        HorticultureCrop: null,
        /*Dairy fields*/
        DairyCompany: null,
        MilkSolids: 0,
        CowsMilked: 0,
        /*Arable fields*/
        ArableMaize: 0,
        ArableOats: 0,
        ArableBarley: 0,
        ArableBrassica: 0,
        ArableLucerne: 0,
        ArableBroadleaf: 0,
        ArableHay: 0,
        ArableAnimalPasture: 0,
        ArablePermanentPasture: 0,
        ArableKiwifruit: 0,
        ArablePipfruit: 0,
        ArableVegetables: 0,
        ArableViticulture: 0,
        ArableOrchard: 0,
        ArableOtherGrain: 0,
        ArableChicory: 0,
        ArablePlantain: 0,
        ArableRyegrass: 0,
        ArableClover: 0,
        ArableOtherSeeds: 0,
        ArableFodderCrops: 0,
        ArableMixed: 0,
        ArableOther: 0,
        /*Forestry fields*/
        /*ForestryCertificate:0,*/
        ForestryRadiata: 0,
        ForestryDouglasFir: 0,
        ForestryEucalyptus: 0,
        ForestryAcacia: 0,
        ForestryNative: 0,
        CarbonCredits: false,
        ContractManagement: false,
        /*Livestock fields*/
        LivestockBeefHeifers: 0,
        LivestockDiaryHeifers1Year: 0,
        LivestockDiaryHeifers2Year: 0,
        LivestockDairyCows: 0,
        LivestockUnits: 0,
        /*Additional information*/
        SaleMethod: null,
        ListPrice: 0,
        SalePrice: null,
        ListDate: '',
        AgreementDate: '',
        UnconditionalDate: '',
        SettlementDate: null,
        Valuation: 0,
        ValuationDate: null,
        LandValue: 0,
        ValuationImprovement: 0,
        //fields used by API's but not by forms
        Latitude:null,
        Longitude:null,
        LinzTlaId: 0,
        TlaId: 0,
        TownCity: null,
        LandClass: null,
        Created: null
    });
    const newrural = { ...rural }
    const [isVisibleTopButton, setIsVisibleTopButton] = useState(false);
    const [errorMessage, seterrorMessage] = useState('');
    const listDateObj = new Date(rural.ListDate);
    const agreementDateObj = new Date(rural.AgreementDate);
    var orgEntered = "";
    const config = useAppConfig();
    useEffect(() => {
    const fetchReturnsList = async () => {
        //console.log("profile");
        const url = "api/ReturnList/GetReturnLists";
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        const accessToken = await GetAccessToken(tokenRequest);

        try {
            await fetch(url,
                {
                    method: "POST",
                    headers: new Headers(
                        {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${accessToken}`
                        }),
                    body: JSON.stringify({ fromDate: SelectedDateRange[0], toDate: SelectedDateRange[1], SelectedCategory: SelectedCategory, SelectedReturnStatus: SelectedReturnStatus, SelectedReturnSaleMethod: SelectedReturnSaleMethod })
                })
                .then((response) => {
                    console.log(response, 'response');
                    if (response.status !== 200 && response.status !== 201) {
                        console.log("not ok" + response.status);
                    }
                    else {
                        return response.json()
                    }
                })
                .then(data => {
                    console.log(data)
                    if (data !== null && data !== undefined) {
                        const newdata = data.find(x => x.saleId === props.saleId);
                        newrural.SaleId = newdata.datamineSaleId;
                        newrural.DbId = newdata.saleId;
                        newrural.OfficeReinzId = newdata.organisationName;
                        newrural.ReturnType = newdata.saleType;
                        newrural.SaleIsConjoint = newdata.SaleIsConjoint;;
                        newrural.ConjointOfficeReinzId = newdata.participantOfficeReinzIds;
                        newrural.AdminNotes = newdata.adminNotes;
                        newrural.ReturnPeriod = newdata.unconditionalDate !== null ? (newdata.unconditionalDate).slice(0, 10) : null;
                        newrural.ExternalId = newdata.externalId;
                        newrural.AddressSearch = newdata.fullAddress;
                        newrural.ValRef = newdata.valRef;
                        newrural.Unit = newdata.unit;
                        newrural.Suffix = newdata.suffix !== null ? newdata.suffix : "";
                        newrural.StreetNumber = newdata.streetNumber;
                        newrural.Street = newdata.street;
                        newrural.Suburb = newdata.suburb;
                        newrural.PostalCode = newdata.postalCode;
                        newrural.CertificateOfTitle = newdata.certificateOfTitle;
                        newrural.FreeholdStatus = newdata.freeholdStatus;
                        newrural.Category = newdata.saleCategory;
                        newrural.Valuation = newdata.valuation;

                        //fields not present on rural form
                        /*newrural.Comments = null;*/
                        newrural.DiseaseStatus = null;
                        newrural.LifestyleCategory = null;
                        newrural.LivestockCategory = null;
                        newrural.Outlook = null;
                        newrural.RuralCouncil = null;
                        /*Rural info*/
                        newrural.BareLand = newdata.bareLand !== null ? newdata.bareLand:false;
                        newrural.Farmlet = newdata.farmlet;
                        newrural.Contour = newdata.contour;
                        newrural.IrrigationType = newdata.irrigationType;
                        newrural.WaterSupply = newdata.waterSupply;
                        newrural.LandArea = String(newdata.landArea).replace(/sqm$/, "").trim();
                        //newrural.LandArea = newdata.landArea.slice(0,5);
                        //newrural.LandArea = newdata.landArea ?? newdata.landArea.slice(0,newdata.landArea.indexOf('s'));
                        newrural.Bedrooms = newdata.bedrooms;
                        newrural.Bathrooms = newdata.bathrooms;
                        newrural.Dwellings = newdata.dwellings;
                        newrural.MainDwelling = newdata.mainDwelling;
                        newrural.AdditionalDwelling = newdata.additionalDwelling;
                        newrural.Improvements = newdata.improvements;
                        newrural.Comments = newdata.comments;
                        newrural.SaleIsConjoint = newdata.saleIsConjoint;
                        /*newrural.AdditionalComments = newdata.comments;*/
                        newrural.Suppressed = newdata.suppressed;
                        newrural.GST = newdata.gst;
                        /*Horticulture fields*/
                        newrural.HorticultureCrop = newdata.horticultureCrop;
                        /*Dairy fields*/
                        newrural.DairyCompany = newdata.dairyCompany;
                        newrural.MilkSolids = newdata.milkSolids;
                        newrural.CowsMilked = newdata.cowsMilked;
                        /*Arable fields*/
                        newrural.ArableMaize = newdata.arableMaize;
                        newrural.ArableOats = newdata.arableOats;
                        newrural.ArableBarley = newdata.arableBarley;
                        newrural.ArableBrassica = newdata.arableBrassica;
                        newrural.ArableLucerne = newdata.arableLucerne;
                        newrural.ArableBroadleaf = newdata.arableBroadleaf;
                        newrural.ArableHay = newdata.arableHay;
                        newrural.ArableAnimalPasture = newdata.arableAnimalPasture;
                        newrural.ArablePermanentPasture = newdata.arablePermanentPasture;
                        newrural.ArableKiwifruit = newdata.arableKiwifruit;
                        newrural.ArablePipfruit = newdata.arablePipfruit;
                        newrural.ArableVegetables = newdata.arableVegetables;
                        newrural.ArableViticulture = newdata.arableViticulture;
                        newrural.ArableOrchard = newdata.arableOrchard;
                        newrural.ArableOtherGrain = newdata.arableOtherGrain;
                        newrural.ArableChicory = newdata.arableChicory;
                        newrural.ArablePlantain = newdata.arablePlantain;
                        newrural.ArableRyegrass = newdata.arableRyegrass;
                        newrural.ArableClover = newdata.arableClover;
                        newrural.ArableOtherSeeds = newdata.arableOtherSeeds;
                        newrural.ArableFodderCrops = newdata.arableFodderCrops;
                        newrural.ArableMixed = newdata.arableMixed;
                        newrural.ArableOther = newdata.arableOther;
                        /*Forestry fields*/
                        /*ForestryCertificate=0;*/
                        newrural.ForestryRadiata = newdata.forestryRadiata;
                        newrural.ForestryDouglasFir = newdata.forestryDouglasFir;
                        newrural.ForestryEucalyptus = newdata.forestryEucalyptus;
                        newrural.ForestryAcacia = newdata.forestryAcacia;
                        newrural.ForestryNative = newdata.forestryNative;
                        newrural.CarbonCredits = newdata.carbonCredits;
                        newrural.ContractManagement = newdata.contractManagement;
                        /*Livestock fields*/
                        newrural.LivestockBeefHeifers = newdata.livestockBeefHeifers;
                        newrural.LivestockDiaryHeifers1Year = newdata.livestockDiaryHeifers1Year;
                        newrural.LivestockDiaryHeifers2Year = newdata.livestockDiaryHeifers2Year;
                        newrural.LivestockDairyCows = newdata.livestockDairyCows;
                        newrural.LivestockUnits = newdata.livestockUnits;

                        /*Additional fields*/
                        newrural.SaleMethod = newdata.saleMethod;
                        newrural.ListPrice = newdata.listPrice;
                        newrural.SalePrice = newdata.salePrice;
                        newrural.ListDate = newdata.listDate !== null ? (newdata.listDate).slice(0, 10) : null;
                        newrural.AgreementDate = newdata.agreementDate !== null ? (newdata.agreementDate).slice(0, 10) : null;
                        newrural.UnconditionalDate = newdata.unconditionalDate !== null ? (newdata.unconditionalDate).slice(0, 10) : null;
                        newrural.SettlementDate = newdata.settlementDate !== null ? (newdata.settlementDate).slice(0, 10) : null;
                        newrural.Valuation = newdata.valuation;
                        newrural.ValuationDate = newdata.valuationDate !== null? (newdata.valuationDate).slice(0, 10) :null;
                        newrural.LandValue = newdata.landValue;
                        newrural.ValuationImprovement = newdata.valuationImprovement;
                        //fields used by API's but not by forms
                        newrural.Latitude = newdata.latitude !== null ? newdata.latitude : null;
                        newrural.Longitude = newdata.longitude !== null ? newdata.longitude : null;
                        newrural.LinzTlaId = newdata.linzTlaId;
                        newrural.TlaId = newdata.tlaId;
                        newrural.TownCity = newdata.townCity;
                        newrural.LandClass = newdata.landClass;
                        newrural.Created = (newdata.created).slice(0, 10);
                        setrural(newrural);
                    }
                    console.log(newrural);
                })
                //setIsLoading(false)
                .catch(error => {
                    console.error('Error:', error);
                });
        }
        catch (error) {
            if (error.response) {
                console.log(error);
            }
        }
    }
    fetchReturnsList();
    }, [])

    // Scroll event listener to show/hide the button
    useEffect(() => {
        const handleScroll = () => {
            console.log('window.scrollY:', window.scrollY);
            console.log('document.documentElement.scrollTop:', document.documentElement.scrollTop);

            if (window.scrollY > 900 || document.documentElement.scrollTop > 900) {
                setIsVisibleTopButton(true);
            } else {
                setIsVisibleTopButton(false);
            }
        };
        // Attach scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const isClicked = () => {
        if (showResidential === true) {
            setshowResidential(false);
        } else {
            setshowResidential(true);
        }
        handleClose();
    }
    function handle(e) {
        const newrural = { ...rural }
        newrural[e.target.id] = e.target.value
        const { id, value, type } = e.target;

        let updatedValue = 0;
        if (id === "LandAreaSelect") {
            // Convert FloorArea when unit changes
            if (value === "1") /*&& rural.AreaUnit === "1"*/ {
                // Ha → m²
                updatedValue = rural.LandArea * 10000;
            } else if (value === "2") /*&& rural.AreaUnit === "2"*/ {
                // m² → Ha
                updatedValue = rural.LandArea / 10000;
            }

            setrural({
                ...rural,
                LandArea: updatedValue,
                AreaUnit: value,
            });
        } else if (id === "LandArea") {
            setrural({
                ...rural,
                /*Unit: value,*/
                LandArea: value
            });
        }
        // Convert numeric inputs to numbers
        else if (type === "number") {
            newrural[id] = value === '' ? '' : Number(value);
            setrural(newrural);
        }
        else {
            setrural(newrural)
        }
        console.log(newrural)
    }

    function checkboxHandle(e) {
        const { name, checked } = e.target;
        setrural((prevData) => {
            if (name === "BareLand" && checked) {
                return ({ ...prevData, BareLand: true, Farmlet: false })
            }
            if (name === "Farmlet" && checked) {
                return ({ ...prevData, BareLand: false, Farmlet: true })
            }
            return ({ ...prevData, [name]: checked })
        }
        )
        //const { name, value, checked, type } = e.target;
        //setrural
        //    (prevData =>
        //    ({
        //        ...prevData,
        //        [name]: type ===
        //            'checkbox' ? checked : value
        //    }));
    }

    const [showLastMonths] = useState([
        {
            key: 1,
            value: (new Date((new Date()).setMonth((new Date()).getMonth()))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth()))).getFullYear()
        },
        {
            key: 2,
            value: (new Date((new Date()).setMonth((new Date()).getMonth() - 1))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth() - 1))).getFullYear()
        },
        {
            key: 3,
            value: (new Date((new Date()).setMonth((new Date()).getMonth() - 2))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth() - 2))).getFullYear()
        },
        {
            key: 4,
            value: (new Date((new Date()).setMonth((new Date()).getMonth() - 3))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth() - 3))).getFullYear()
        }
    ]);
    var addressEntered = "";
    function handleAddressSearch(e) {
        const { id } = e.target;
        addressEntered = e.target.value;
        setrural((prev) => ({
            ...prev,
            AddressSearch: addressEntered
        }));
        //setSelectedAddress(addressEntered);
        setAddressIsVisible(true);
        if (addressEntered.length >= 6) {
            handleAddress();
        }
    }
    const handleAddress = async () => {
        const url = "api/address/GetAddress";
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        const accessToken = await GetAccessToken(tokenRequest);
        try {
            fetch(url, {
                method: "POST",
                headers: new Headers({
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }),
                body: JSON.stringify(addressEntered)
            })
                .then((response) => {
                    console.log(response, 'response');
                    if (response.status !== 200 && response.status !== 201) {
                        console.log("not ok" + response.status);
                    }
                    else {
                        return response.json()
                    }
                }).then(data => {
                    console.log(data)
                    if (data !== null && data !== undefined) {
                        setSearchResults(data);
                    }
                })
                .catch(error => {
                    console.error('Error fetching addresses:', error);
                });
        }
        catch (error) {
            if (error.response) {
                console.log(error);
            }
        }

    }
    function scrollTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    function handleOfficeSearch(e) {
        const { id } = e.target;
        orgEntered = e.target.value;
        setrural((prev) => ({
            ...prev,
            OfficeReinzId: orgEntered
        }));
        setAgencyIsVisible(true);
        if (orgEntered.length >= 4) {
            handleConjointOffices();
        }
    };
    const handleSelectAgency = (agency) => {
        setrural((prevData) => ({ ...prevData, OfficeReinzId: agency }));
        setAgencyIsVisible(false);
    };
    //Submit delete request
    const sale = {
        saleId: props.saleId
    };
    const SubmitDelete = async (e) => {
        /*e.preventDefault();*/
        setShowModalDelete(false);
        //alert("Hello1");

        const url = "api/DeleteReturn/DeleteReturn/?id=" + props.saleId;
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        try {
            const accessToken = await GetAccessToken(tokenRequest);
            //fetch
            fetch(url,
                {
                    method: 'DELETE',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify(sale),
                })
                .then((response) => {
                    //console.log(response, 'response');
                    if (response.status !== 200 && response.status !== 201) {
                        //console.log("not ok" + response.status);
                    }
                    else {
                        return response.json()
                    }
                }).then(data => {
                    setData(data)
                    //console.log(data)
                })
                .catch((err) => {
                    console.log(err);
                });
        }
        catch (error) {
            if (error.response) {
                console.log(error);
            }
        }
    }
    //
    const handleDeleteSaleAlert = () => {
        setData(false);
        props.onGoBack();
        alert("Return Deleted");

    };

    //Edit/Update a return
    const SubmitUpdate = async (e) => {
        e.preventDefault();
        //scrollTop();
        /*alert("Hello1");*/
        const form = document.getElementById('AddRuralReturnForm');;
        if (!form.checkValidity()) {
            e.stopPropagation();
            setValidated(true);
            seterrorMessage(true);
            setValidationError('Please fill in all required fields.');
            setError('Please fill in all required fields.');
            return; // Prevent submission if invalid
        }
        setValidated(true);
        setError(null);
        setValidationError(null);
        seterrorMessage(false);

        const url = "api/RuralReturn/UpdateRuralReturn/?id=" + props.saleId;
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        try {
            setLoading(true);
            const accessToken = await GetAccessToken(tokenRequest);
            //fetch
            const response= await fetch(url,
                {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify(rural),

                });
            if (!response.ok) {
                console.log("not ok" + response.status);
                throw new Error('Network response was not ok');
            }
            else {
                const data = await response.json();
                setShowToast(true);
                setLoading(false);
                /*setMessage(true);*/
                //setMessage('Sale updated successfully');
                //seterrorMessage(false);
                
                //setTimeout(() => {
                //    setMessage(false);
                //}, 5000);
            }
        }
        catch (error) {
            console.log(error);
            setLoading(false);
            seterrorMessage(true);
            setMessage('Error saving data. Please try again.');
            setTimeout(() => {
                setMessage(false);
            }, 5000);
        }
    }
    function handleConjointOfficesSearch(e) {
        const { id } = e.target;
        orgEntered = e.target.value;
        setrural((prev) => ({
            ...prev,
            ConjointOfficeReinzId: orgEntered
        }));
        setOrgIsVisible(true);
        /*setSelectedOrg(orgEntered);*/
        if (orgEntered.length >= 4) {
            handleConjointOffices();
        }
    }
    const handleConjointOffices = async () => {
        const url = "api/organisation/GetOrganisation";
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        const accessToken = await GetAccessToken(tokenRequest);
        try {
            fetch(url, {
                method: "POST",
                headers: new Headers({
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }),
                body: JSON.stringify(orgEntered)
            })
                .then((response) => {
                    console.log(response, 'response');
                    if (response.status !== 200 && response.status !== 201) {
                        console.log("not ok" + response.status);
                    }
                    else {
                        return response.json()
                    }
                }).then(data => {
                    console.log(data)
                    if (data !== null && data !== undefined) {
                        setOrgSearchResults(data);
                        setAgencySearchResults(data);
                        //setOrgIsVisible(true);
                        //setOrgIsVisible(true);
                    }
                })
                .catch(error => {
                    console.error('Error fetching organisations', error);
                });
        }
        catch (error) {
            if (error.response) {
                console.log(error);
            }
        }
    }
    const handleSelectAddress = (address) => {
        //old source code not recommended
        //setIsVisible(false);
        //newrural.ValRef = address.valRef;
        //newrural.AddressSearch = address.addressSearch;
        //newrural.Unit = address.unit;
        //newrural.Suffix = address.suffix;
        //newrural.StreetNumber = address.streetNumber.toString();
        //newrural.Street = address.street;
        //newrural.Suburb = address.suburbName;
        //newrural.TownCity = address.townCity;
        //newrural.PostalCode = address.postcode;
        //newrural.LandValue = address.landValue;
        //newrural.Longitude = address.longitude;
        //newrural.Latitude = address.latitude;
        //newrural.Valuation = address.councilValuation;
        //newrural.Bathrooms = address.bathrooms;
        //newrural.Bedrooms = address.bedrooms;
        //newrural.FloorArea = address.floorArea;
        //newrural.LandArea = address.landArea;
        //newrural.ValuationImprovement = address.improvementValue;
        //newrural.CertificateOfTitle = address.certificateOfTitle;
        //setrural(newrural);

        //new source code
        const updatedResidential = {
            ...newrural, // or use the current residential state if needed
            ValRef: address.valRef,
            AddressSearch: address.addressSearch,
            Unit: address.unit,
            Suffix: address.suffix,
            StreetNumber: address.streetNumber.toString(),
            Street: address.street,
            Suburb: address.suburbName,
            TownCity: address.townCity,
            PostalCode: address.postcode,
            LandValue: address.landValue,
            Longitude: address.longitude,
            Latitude: address.latitude,
            Valuation: address.councilValuation,
            Bathrooms: address.bathrooms,
            Bedrooms: address.bedrooms,
            FloorArea: address.floorArea,
            LandArea: address.landArea/10000,
            ValuationImprovement: address.improvementValue,
            CertificateOfTitle: address.certificateOfTitle,
            FreeholdStatus: address.freeholdStatus,
            Category: address.propertyCategory
        };

        setrural(updatedResidential);
        setAddressIsVisible(false); // Hide the suggestion list after selection
    }

    const handleSelectOrg = (org) => {
        if (org && !searchOrgsResults.includes(org.trim())) {
            setOrgsSearchResults((searchOrgsResults) => {
                const updatedOrgsList = [...searchOrgsResults, org.trim()]
                // Update state
                setrural((prevData) => ({ ...prevData, ConjointOfficeReinzId: org }));
                /*setOrgSearchResults(['']);*/
                return updatedOrgsList;// Return the updated list for the state
            });
        }
        setOrgIsVisible(false);
        /*setOrgsIsVisible(true);*/
    };

    const handleRemoveSearchTerm = (org) => {
        setOrgsSearchResults((searchOrgsResults) => {
            const updatedOrgsList = searchOrgsResults.filter((searchorg) => searchorg !== org)
            //const updatedResidential = {
            //    ...newresidential,
            //    ConjointOfficeReinzId: updatedOrgsList
            //};
            //// Update state
            //setresidential(updatedResidential);

            // Only update residential if you're removing the currently selected one
            setrural((prev) => ({
                ...prev,
                ConjointOfficeReinzId: updatedOrgsList.includes(prev.ConjointOfficeReinzId) ? prev.ConjointOfficeReinzId : ''
            }));
            return updatedOrgsList;// Return the updated list for the state
        });
    }

    const renderTooltip_returntype = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            Changing this to a Residential Return will remove all rural specific fields
        </Tooltip>
    );

    const renderTooltip_saleisconjoint = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            Marking a sale as conjoint will allow REINZ to match this sale with returns submitted by participating offices
        </Tooltip>
    );

    const renderTooltip_returnperiod = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            Return Period will be determined by the date entered in the Unconditional Date field below
        </Tooltip>
    );

    const renderTooltip_externalid = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            If your agency requires your return to contain an ID for reporting purposes, enter it here
        </Tooltip>
    );

    const renderTooltip_supresssale = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            Supressing a sale prevents it being searchable until the sale has settled or 6 months.
            Supressing sales is actively monitored by REINZ and you will be asked the reason why it has supressed.S
            Supressing should only be done for legal privacy reasons.
        </Tooltip>
    );

    const renderTooltip_unconditionaldate = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            Unconditional Date will be used to determine which Return Period this return will be submitted under.
        </Tooltip>
    );
    const renderTooltip_listdate = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            The date which agency signed agreement with vendor to list property.
        </Tooltip>
    );

    const renderTooltip_agreementdate = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            The date which sale and purchase agreement was signed.
        </Tooltip>
    );
    return (
        <>
            <Modal size="lg" show={showModal} onHide={handleClose} animation={false} className="dark-mode-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Are you sure you want to change this return from rural to residential return?</Modal.Title>
                </Modal.Header>
                <Modal.Body>This will remove all rural data from the return form</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                    Cancel
                    </Button>
                    <Button style={{ backgroundColor: "#331b8c" }} onClick={isClicked}>
                    Confirm
                    </Button>
                </Modal.Footer>
            </Modal>

            {data === true && handleDeleteSaleAlert()}
            <Modal size="lg" show={showModalDelete} onHide={handleCloseModalDelete} animation={false} className="dark-mode-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Are you sure you want to delete this return?</Modal.Title>
                </Modal.Header>
                <Modal.Body>This return will be deleted immediatly and you will be returned to the Returns List page</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalDelete}>
                        Cancel
                    </Button>
                    <Button style={{ backgroundColor: "#331b8c" }} onClick={() => SubmitDelete()}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
            {showResidential ? <AddResidentialReturn {...rural} /> :
                <>                    
                    <div className="container" id="AddRuralReturn">
                        <h1>Update a Rural Return</h1>
                        <Button style={{ backgroundColor: "#331b8c", border: 'none' }} size="sm" onClick={props.onGoBack}>
                            <i className="bi bi-arrow-left-square"></i>&nbsp;Back
                        </Button><br />
                        <Button style={{ backgroundColor: "#331b8c", border: 'none', float: 'right' }} id="Delete" size="sm" onClick={() => {
                            setShowModalDelete(true)
                        }}><i className="bi bi-trash3-fill"></i>&nbsp;Delete</Button>
                        {isVisibleTopButton && (
                            <Button onClick={scrollTop} id="GoToTop" title="Go to top">
                                <i className="fas fa-arrow-up" style={{ fontSize: '20px' }}></i>
                            </Button>
                        )}
                        <form id="AddRuralReturnForm" noValidate validated={validated}>
                             <Toast
                                show={showToast}
                                style={{
                                    position: 'fixed',
                                    top: '25%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 9999,
                                    minWidth: '300px',
                                    textAlign: 'center',
                                    backgroundColor: '#f8f9fa', // Optional: Light background
                                    border: '1px solid #28a745'
                                }}
                                onClose={() => setShowToast(false)}>
                                <Toast.Header style={{
                                    color: 'green',
                                    fontWeight: 'bold',
                                    fontSize: '1.2rem'
                                }}>
                                    <strong className="me-auto">Sale updated successfully!</strong>
                                </Toast.Header>
                            </Toast>
                            <h4 style={{ color: "#ffffff" }}>Primary Property Information</h4>
                            <div className="form-group">
                                <label className="labelClass" htmlFor="CompanyInput">Company <span style={{ color: 'red' }}>*</span></label>
                                {/*<label required>{rural.OfficeReinzId}</label>*/}
                                <input type='text' className="form-control" id="OfficeReinzId" placeholder="Start typing to search through Agencies"
                                    value={rural.OfficeReinzId || ''} onChange={(e) => handleOfficeSearch(e)}
                                    required></input>
                                {isAgencyVisible &&
                                    <ul id="OfficeReinzId" className="List">
                                        {searchAgencyResults.map((agency, index) => (
                                            <li key={index} onClick={() => handleSelectAgency(agency)}>
                                                {agency}
                                            </li>
                                        ))}
                                    </ul>
                                }
                                {(rural.OfficeReinzId === '' || rural.OfficeReinzId === null) &&
                                    //<label as="label" className="required" style={{ color: 'red' }}>
                                    //    Company is required
                                //</label>}
                                    <div style={{ color: 'red' }}>{error}</div>}
                            </div>
                            <div className="form-group">
                                <label className="labelClass" htmlFor="ReturnTypeInput" id="ReturnType" value={rural.ReturnType}>Return Type<OverlayTrigger
                                    placement="top" overlay={renderTooltip_returntype}><sup>?</sup></OverlayTrigger>
                                </label>
                                <label value={rural.ReturnType}>Rural&nbsp;&nbsp;</label>
                                <button className="btnClass" onClick={(e) => { setShowModal(true); e.preventDefault() }} >
                                    <i className="bi bi-arrow-repeat iconStyles" style={{ marginRight: "8px" }}></i>
                                    Change Return Type
                                </button>
                            </div>
                            <div className="form-group" id="CheckboxClass">
                                <label className="labelClass" htmlFor="SaleIsConjointInput">Sale Is Conjoint<OverlayTrigger
                                    placement="top" overlay={renderTooltip_saleisconjoint}><sup>?</sup></OverlayTrigger>
                                </label>
                                <Checkbox id="SaleIsConjoint" name="SaleIsConjoint"
                                    checked={rural.SaleIsConjoint}
                                    onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />
                            </div>
                            <div className="form-group">
                                <label className="labelClass" htmlFor="ConjointCompaniesInput">Conjoint Companies</label>
                                <div className="input-group">
                                    <span class="input-group-text" id="dollar-sign" >
                                        <i class="bi bi-search iconStyles"></i>
                                    </span>
                                    <input type="text" className="form-control" id="ConjointOfficeReinzId" placeholder="Start typing to search through Agencies"
                                        value={rural.ConjointOfficeReinzId || null} onChange={(e) => handleConjointOfficesSearch(e)} />
                                </div>
                                {isOrgVisible &&
                                    <ul id="ConjointOfficeReinzId" className="List">
                                        {searchOrgResults.map((org, index) => (
                                            <li key={index} onClick={() => handleSelectOrg(org)}>
                                                {org}
                                            </li>
                                        ))}
                                    </ul>
                                }
                                {isOrgsVisible &&
                                    <ul id="ConjointOfficeReinzId" className="List">
                                        {searchOrgsResults.map((org, index) => (
                                            <li key={index}>
                                                <button id="button" onClick={() => handleRemoveSearchTerm(org)}><i className="bi bi-trash3-fill"></i>&nbsp;Remove</button>&nbsp;&nbsp;&nbsp;
                                                <span>{org}</span>

                                            </li>
                                        ))}
                                    </ul>
                                }
                            </div>
                            <div className="form-group">
                                <label className="labelClass" htmlFor="REINZAdminNotesInput">REINZ Admin Notes</label>
                                <textarea id="AdminNotes" className="form-control" rows="2" value={rural.AdminNotes} onChange={(e) => handle(e)}></textarea>
                            </div>
                            <div className="form-group">
                                <label htmlFor="ReturnPeriodInput">Return Period<OverlayTrigger placement="top"
                                    overlay={renderTooltip_returnperiod}><sup>?</sup></OverlayTrigger>
                                </label>
                                <div id="SelectStyle">
                                    <select name="ReturnPeriod" className="form-control">
                                        value={rural.ReturnPeriod}
                                        onChange={(e) => handle(e)}
                                        {showLastMonths.map((info) => (
                                            <option className="form-control" key={info.key} value={info.value}>{info.value}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="ExternalIDInput">External ID<OverlayTrigger
                                    placement="top" overlay={renderTooltip_externalid}><sup>?</sup></OverlayTrigger>
                                </label>
                                <input type="text" className="form-control" id="ExternalId" value={rural.ExternalId} onChange={(e) => handle(e)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="AddressSearchInput">Address Search</label>
                                <div className="input-group">
                                    <span class="input-group-text" id="dollar-sign" >
                                        <i class="bi bi-search iconStyles"></i>
                                    </span>
                                    <input type="text" className="form-control" id="AddressSearch" name="AddressSearch" value={rural.AddressSearch}
                                        onChange={(e) => handleAddressSearch(e)} placeholder="Start typing to search through addresses" />
                                </div>
                                {/*{(selectedAddress === null || selectedAddress==='') &&*/}
                                {/*    <p style={{ color: "#ffffff", fontSize: "1rem" }}>Selecting an address with this search box will overwrite any changes you've made to this form</p>*/}
                                {/*}*/}
                                {isAddressVisible &&
                                    <ul id="addressSearch" className="List">
                                        {searchResults.map((address) => (
                                            <li key={address.id} onClick={() => handleSelectAddress(address)} style={{ color: "#ffffff" }}>
                                                {address.addressSearch}
                                            </li>
                                        ))}
                                    </ul>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="ValRefInput">Val Ref</label>
                                <input type="text" className="form-control" id="ValRef" value={rural.ValRef} onChange={(e) => handle(e)} placeholder="Example 22900/42602" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="UnitInput">Unit Number</label>
                                <input type="text" className="form-control" id="Unit" value={rural.Unit} onChange={(e) => handle(e)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="SuffixInput">Suffix</label>
                                <input type="text" className="form-control" id="Suffix" value={rural.Suffix} onChange={(e) => handle(e)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="StreetNumberInput">Street Number <span style={{ color: 'red' }}>*</span></label>
                                <input type="text" className="form-control" id="StreetNumber" value={rural.StreetNumber} onChange={(e) => handle(e)} required />
                                {(rural.StreetNumber === "" || rural.StreetNumber === null) &&
                                    /*<label as="label" style={{ color: 'red' }} className="required">Street Number is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="StreetInput">Street Name <span style={{ color: 'red' }}>*</span></label>
                                <input type="text" className="form-control" id="Street" value={rural.Street} onChange={(e) => handle(e)} required />
                                {(rural.Street === "" || rural.Street === null) &&
                                    /*<label as="label" style={{ color: 'red' }} className="required">Street Name is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="SuburbInput">Suburb <span style={{ color: 'red' }}>*</span></label>
                                <input type="text" className="form-control" id="suburbName" value={rural.Suburb} onChange={(e) => handle(e)} required
                                    placeholder="Start typing to search through suburbs" />
                                {(rural.Suburb === "" || rural.Suburb === null) &&
                                    /*<label as="label" style={{ color: 'red' }} className="required">Suburb is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }                                
                            </div>
                            <div className="form-group">
                                <label htmlFor="PostalCodeInput">Post Code</label>
                                <input type="number" className="form-control" id="PostalCode" value={(rural.PostalCode).toString().padStart(4,"0")} onChange={(e) => handle(e)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="CertificateOfTitleInput">Title</label>
                                <input type="text" className="form-control" id="CertificateOfTitle" value={rural.CertificateOfTitle} onChange={(e) => handle(e)} />
                            </div>
                            {/*Latitude*/}
                            <div style={{ display: "none" }}>
                                <label column>Latitude</label>
                                <input type="text" className="form-control" id="Latitude" value={newrural.Latitude} onChange={(e) => handle(e)} />
                            </div>
                            {/*Longitude*/}
                            <div style={{ display: "none" }}>
                                <label column>Longitude</label>
                                <input type="text" className="form-control" id="Longitude" value={newrural.Longitude} onChange={(e) => handle(e)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="FreeholdStatusInput">Freehold Status <span style={{ color: 'red' }}>*</span></label>
                                <div id="SelectStyle">
                                    <select name="FreeholdStatus" className="form-control" id="FreeholdStatus" value={rural.FreeholdStatus} onChange={(e) => handle(e)} required>
                                        <option className="form-control"></option>
                                        <option className="form-control" value="Unknown">Unknown</option>
                                        <option className="form-control" value="Freehold">Freehold</option>
                                        <option className="form-control" value="Leasehold">Leasehold</option>
                                        <option className="form-control" value="Crosslease">Crosslease</option>
                                        <option className="form-control" value="UnitTitle">Unit Title</option>
                                        <option className="form-control" value="Company">Company</option>
                                        <option className="form-control" value="Strata">Strata</option>
                                    </select>
                                </div>
                                {(rural.FreeholdStatus === "" || rural.FreeholdStatus === null) &&
                                    /*<label as="label" className="required" style={{ color: 'red' }}>Freehold Status is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="CategoryInput">Property Category <span style={{ color: 'red' }}>*</span></label>
                                <div id="SelectStyle">
                                    <select name="Category" className="form-control" id="Category" value={rural.Category} onChange={(e) => handle(e)} required>
                                        <option className="form-control"></option>
                                        <option className="form-control" value="Lifestyle Blocks">Lifestyle Blocks</option>
                                        <option className="form-control" value="Rural-Other">Rural - Other</option>
                                        <option className="form-control" value="Horticulture">Horticulture</option>
                                        <option className="form-control" value="Dairy">Dairy</option>
                                        <option className="form-control" value="Dairy Support">Dairy Support</option>
                                        <option className="form-control" value="Arable">Arable</option>
                                        <option className="form-control" value="Forestry">Forestry</option>
                                        <option className="form-control" value="Livestock">Livestock</option>
                                        <option className="form-control" value="Livestock-Finishing">Livestock - Finishing</option>
                                        <option className="form-control" value="Livestock-Grazing">Livestock - Grazing</option>
                                        <option className="form-control" value="Livestock-Special">Livestock - Special</option>
                                    </select>
                                </div>
                                {(rural.Category === "" || rural.Category === null) &&
                                    /*<label as="label" className="required" style={{ color: 'red' }}>Property Category is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }
                            </div>
                            {/*Rural Information*/}
                            <h4 style={{ color: "#ffffff" }}>Rural Information</h4>
                            <div className="form-group" id="CheckboxClass">
                                <label className="labelClass" htmlFor="BarelandInput">Bareland</label>
                                <Checkbox id="BareLand" name="BareLand"
                                    checked={rural.BareLand}
                                    onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                {rural.Category === "Lifestyle Blocks" && <>
                                    <label className="labelClass" column>Farmlet</label>
                                    <Checkbox id="Farmlet" name="Farmlet"
                                        checked={rural.Farmlet}
                                        onChange={(e) => checkboxHandle(e)}
                                        sx={{
                                            color: '#563abe',
                                            '&.Mui-checked': {
                                                color: '#563abe',
                                            },
                                            padding: 0,
                                        }}
                                    />
                                </>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="ContourInput">Contour <span style={{ color: 'red' }}>*</span></label>
                                <div id="SelectStyle">
                                    <select name="Contour" className="form-control" id="Contour" value={rural.Contour} onChange={(e) => handle(e)} required>
                                        <option className="form-control"></option>
                                        <option className="form-control" value="Flat">Flat</option>
                                        <option className="form-control" value="Flat/Rolling">Flat / Rolling</option>
                                        <option className="form-control" value="Rolling">Rolling</option>
                                        <option className="form-control" value="Rolling/Steep">Rolling / Steep</option>
                                        <option className="form-control" value="Steep/Rugged">Steep / Rugged</option>
                                    </select>
                                </div>
                                {(rural.Contour === "" || rural.Contour === null) &&
                                    /*<label as="label" className="required" style={{ color: 'red' }}>Contour is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="IrrigationTypeInput">Irrigation Type <span style={{ color: 'red' }}>*</span></label>
                                <div id="SelectStyle">
                                    <select name="IrrigationType" className="form-control" id="IrrigationType" value={rural.IrrigationType||"None"}
                                        onChange={(e) => handle(e)} required>
                                        <option className="form-control"></option>
                                        <option className="form-control" value="Rotorainer">Rotorainer</option>
                                        <option className="form-control" value="Centre Pivot">Centre Pivot</option>
                                        <option className="form-control" value="K Line">K Line</option>
                                        <option className="form-control" value="Border Dyke">Border Dyke</option>
                                        <option className="form-control" value="Other">Other</option>
                                        <option className="form-control" value="None">None</option>
                                    </select>
                                </div>
                                {(rural.IrrigationType === "" || rural.IrrigationType === null) &&
                                    /*<label as="label" className="required" style={{ color: 'red' }}>Irrigation Type is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="WaterSupplyInput">Water Supply <span style={{ color: 'red' }}>*</span></label>
                                <div id="SelectStyle">
                                    <select name="WaterSupply" className="form-control" id="WaterSupply" value={rural.WaterSupply} onChange={(e) => handle(e)} required>
                                        <option className="form-control"></option>
                                        <option className="form-control" value="Bores">Bores</option>
                                        <option className="form-control" value="District Supply">District Supply</option>
                                        <option className="form-control" value="Springs/Streams">Springs / Streams</option>
                                        <option className="form-control" value="Dams">Dams</option>
                                        <option className="form-control" value="Other">Other</option>
                                        <option className="form-control" value="None">None</option>
                                    </select>
                                </div>
                                {(rural.WaterSupply === "" || rural.WaterSupply === null) &&
                                    /*<label as="label" className="required" style={{ color: 'red' }}>Water Supply is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="LandAreaInput">Land Area <span style={{ color: 'red' }}>*</span></label>
                                <div className="input-group">
                                    <input type="number" className="form-control" id="LandArea" value={rural.LandArea||''} onChange={(e) => handle(e)} required />
                                    <select className="form-control" id="LandAreaSelect" value={rural.AreaUnit} onChange={(e) => handle(e)}>
                                        <option className="form-control" value="2">Ha</option>
                                        <option className="form-control" value="1"><sub>m</sub>2</option>
                                    </select>
                                </div>
                                {(rural.LandArea === "" || rural.LandArea === null) &&
                                    /*<label as="label" className="required" style={{ color: 'red' }}>Land Area is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }<br/>
                                {rural.LandArea === '0' &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Land Area is 0</label>}<br />
                                {(rural.AreaUnit === 2 && parseInt(rural.LandArea) > 1000000) &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Land Area exceeds 100Ha</label>}<br />
                            </div>
                            <div className="form-group">
                                <label htmlFor="BedroomsInput">No. of Bedrooms <span style={{ color: 'red' }}>*</span></label>
                                <input type="number" className="form-control" id="Bedrooms" value={rural.Bedrooms} onChange={(e) => handle(e)}/>
                                {rural.Category === 'Lifestyle Blocks' && rural.Bedrooms === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>No.of Bedrooms is required</label>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="BathroomsInput">No. of Bathrooms <span style={{ color: 'red' }}>*</span></label>
                                <input type="number" className="form-control" id="Bathrooms" value={rural.Bathrooms} onChange={(e) => handle(e)} />
                                {rural.Category === 'Lifestyle Blocks' && rural.Bathrooms === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>No.of Bathrooms is required</label>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="DwellingsInput">Dwellings Total Count</label>
                                <input type="number" className="form-control" id="Dwellings" value={rural.Dwellings} onChange={(e) => handle(e)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="MainDwellingInput">Main Dwelling {!rural.BareLand && <span style={{ color: 'red' }}>*</span>}</label>
                                <textarea id="MainDwelling" className="form-control" rows="2" value={rural.MainDwelling}
                                   
                                    onChange={(e) => handle(e)} required={!rural.BareLand}></textarea>
                                {!rural.BareLand && (rural.MainDwelling ==='' || rural.MainDwelling === null) &&
                                    <div style={{ color: 'red' }}>{error}</div>
                                    /*<label as="label" className="required" style={{ color: 'red' }}>Main Dwelling is required</label>*/
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="AdditionalDwellingInput">Additional Dwelling</label>
                                <textarea id="AdditionalDwelling" className="form-control" rows="2" value={rural.AdditionalDwelling} onChange={(e) => handle(e)}></textarea>
                            </div>
                            <div className="form-group">
                                <label htmlFor="ImprovementsInput">Improvements (Incl. Other Buildings) {!rural.BareLand && <span style={{ color: 'red' }}>*</span>}</label>
                                <textarea id="Improvements" className="form-control" rows="2" value={rural.Improvements}
                                    
                                    onChange={(e) => handle(e)} required={!rural.BareLand}></textarea>
                                {!rural.BareLand && (rural.Improvements ==='' || rural.Improvements === null) &&
                                    <div style={{ color: 'red' }}>{error}</div>
                                    /*<label as="label" className="required" style={{ color: 'red' }}>Improvements (Incl. Other Buildings) is required</label>*/
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="AdditionalCommentsInput">Additional Comments <span style={{ color: 'red' }}>*</span></label>
                                <textarea id="Comments" className="form-control" rows="2" value={rural.Comments} onChange={(e) => handle(e)} required></textarea>
                                {(rural.Comments === '' || rural.Comments === null) &&
                                    <div style={{ color: 'red' }}>{error}</div>
                                    /*<label as="label" className="required" style={{ color: 'red' }}>Additional Comments is required</label>*/
                                }
                            </div>
                            <div className="form-group" id="CheckboxClass">
                                <label className="labelClass" htmlFor="SupressSaleInput">Supress Sale
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={renderTooltip_supresssale}>
                                        <sup>?</sup>
                                    </OverlayTrigger>
                                </label>
                                <Checkbox id="Suppressed" name="Suppressed" checked={rural.Suppressed} onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />
                            </div>
                            <div className="form-group">
                                {/*Lifestyle Blocks fields*/}
                                {rural.Category === "Lifestyle Blocks" && <>
                                    <label className="labelClass"><h5>Lifestyle Blocks fields</h5></label>
                                    <label className="labelClass" htmlFor="GSTInput">GST Registered</label>
                                    <Checkbox id="GST" name="GST" checked={rural.GST} onChange={(e) => checkboxHandle(e)}
                                        sx={{
                                            color: '#563abe',
                                            '&.Mui-checked': {
                                                color: '#563abe',
                                            },
                                            padding: 0,
                                        }}
                                    />
                                </>
                                }
                                {/*Horticulture fields*/}
                                {rural.Category === "Horticulture" &&
                                    <>
                                        <label className="labelClass"><h5>Horticulture Fields</h5></label>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="HorticultureCropInput">Horticulture Crop</label>
                                            <input type="text" className="form-control" id="HorticultureCrop" name="HorticultureCrop" value={rural.HorticultureCrop} onChange={(e) => handle(e)}></input>
                                        </div>
                                    </>
                                }
                                {/*Dairy fields*/}
                                {rural.Category === "Dairy" &&
                                    <>
                                        <label className="labelClass"><h5>Dairy fields</h5></label>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="DairyCompanyInput">Dairy Company <span style={{ color: 'red' }}>*</span></label>
                                            <div id="SelectStyle">
                                                <select name="DairyCompany" className="form-control" id="DairyCompany" value={rural.DairyCompany} onChange={(e) => handle(e)} required>
                                                    <option className="form-control"></option>
                                                    <option className="form-control" value="Fonterra">Fonterra</option>
                                                    <option className="form-control" value="Open Country Dairy">Open Country Dairy</option>
                                                    <option className="form-control" value="Tatua Co-op">Tatua Co-op</option>
                                                    <option className="form-control" value="Miraka Ltd">Miraka Ltd</option>
                                                    <option className="form-control" value="Westland Milk Products">Westland Milk Products</option>
                                                    <option className="form-control" value="Synlait Canterbury">Synlait Canterbury</option>
                                                    <option className="form-control" value="Other">Other</option>
                                                </select>
                                        </div>
                                        {(rural.DairyCompany === "" || rural.DairyCompany === null) &&
                                            <div style={{ color: 'red' }}>{error}</div>
                                           /* <label as="label" className="required" style={{ color: 'red' }}>Dairy Company is required</label>*/
                                        }
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="MilkSolidsInput">Milk Solids</label>
                                            <input type="number" className="form-control" id="MilkSolids" name="MilkSolids" value={rural.MilkSolids} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="CowsMilkedInput">Cows Milked</label>
                                            <input type="number" className="form-control" id="CowsMilked" name="CowsMilked" value={rural.CowsMilked} onChange={(e) => handle(e)}></input>
                                        </div>
                                    </>
                                }
                                {/*Arable fields*/}
                                {rural.Category === "Arable" &&
                                    <>
                                        <label className="labelClass"><h5>Arable fields</h5></label>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableMaizeInput">Arable: Maize</label>
                                            <input type="number" className="form-control" id="ArableMaize" name="ArableMaize" value={rural.ArableMaize} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableOatsInput">Arable: Oats</label>
                                            <input type="number" className="form-control" id="ArableOats" name="ArableOats" value={rural.ArableOats} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableBarleyInput">Arable: Barley</label>
                                            <input type="number" className="form-control" id="ArableBarley" name="ArableBarley" value={rural.ArableBarley} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableBrassicaInput">Arable: Brassica</label>
                                            <input type="number" className="form-control" id="ArableBrassica" name="ArableBrassica" value={rural.ArableBrassica} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableLucerneInput">Arable: Lucerne</label>
                                            <input type="number" className="form-control" id="ArableLucerne" name="ArableLucerne" value={rural.ArableLucerne} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableBroadleafInput">Arable: Broadleaf</label>
                                            <input type="number" className="form-control" id="ArableBroadleaf" name="ArableBroadleaf" value={rural.ArableBroadleaf} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableHayInput">Arable: Silage/Hay</label>
                                            <input type="number" className="form-control" id="ArableHay" name="ArableHay" value={rural.ArableHay} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableAnimalPastureInput">Arable: Animal Pasture</label>
                                            <input type="number" className="form-control" id="ArableAnimalPasture" name="ArableAnimalPasture" value={rural.ArableAnimalPasture} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArablePermanentPastureInput">Arable: Permanent Pasture</label>
                                            <input type="number" className="form-control" id="ArablePermanentPasture" name="ArablePermanentPasture" value={rural.ArablePermanentPasture} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableKiwifruitInput">Arable: Kiwifruit</label>
                                            <input type="number" className="form-control" id="ArableKiwifruit" name="ArableKiwifruit" value={rural.ArableKiwifruit} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArablePipfruitInput">Arable: Pipfruit</label>
                                            <input type="number" className="form-control" id="ArablePipfruit" name="ArablePipfruit" value={rural.ArablePipfruit} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableVegetablesInput">Arable: Vegetables</label>
                                            <input type="number" className="form-control" id="ArableVegetables" name="ArableVegetables" value={rural.ArableVegetables} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableViticultureInput">Arable: Viticulture</label>
                                            <input type="number" className="form-control" id="ArableViticulture" name="ArableViticulture" value={rural.ArableViticulture} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableOrchardInput">Arable: Orchard</label>
                                            <input type="number" className="form-control" id="ArableOrchard" name="ArableOrchard" value={rural.ArableOrchard} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableOtherGrainInput">Arable: Other Grain</label>
                                            <input type="number" className="form-control" id="ArableOtherGrain" name="ArableOtherGrain" value={rural.ArableOtherGrain} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableChicoryInput">Arable: Chicory</label>
                                            <input type="number" className="form-control" id="ArableChicory" name="ArableChicory" value={rural.ArableChicory} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArablePlantainInput">Arable: Plantain</label>
                                            <input type="number" className="form-control" id="ArablePlantain" name="ArablePlantain" value={rural.ArablePlantain} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableRyegrassInput">Arable: Ryegrass</label>
                                            <input type="number" className="form-control" id="ArableRyegrass" name="ArableRyegrass" value={rural.ArableRyegrass} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableCloverInput">Arable: Clover</label>
                                            <input type="number" className="form-control" id="ArableClover" name="ArableClover" value={rural.ArableClover} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableOtherSeedsInput">Arable: Other Seed</label>
                                            <input type="number" className="form-control" id="ArableOtherSeeds" name="ArableOtherSeeds" value={rural.ArableOtherSeeds} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableFodderCropsInput">Arable: Fodder Crops</label>
                                            <input type="number" className="form-control" id="ArableFodderCrops" name="ArableFodderCrops" value={rural.ArableFodderCrops} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableMixedInput">Arable: Mixed</label>
                                            <input type="number" className="form-control" id="ArableMixed" name="ArableMixed" value={rural.ArableMixed} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ArableOtherInput">Arable: Other</label>
                                            <input type="number" className="form-control" id="ArableOther" name="ArableOther" value={rural.ArableOther} onChange={(e) => handle(e)}></input>
                                        </div>
                                    </>
                                }
                                {/*Forestry fields*/}
                                {rural.Category === "Forestry" &&
                                    <>
                                        <label className="labelClass"><h5>Forestry fields</h5></label>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ForestryCertificateInput">Forestry Certificate</label>
                                            <input type="text" className="form-control" id="ForestryCertificate" name="ForestryCertificate" value={rural.ForestryCertificate} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ForestryRadiataInput">Forestry: Radiata</label>
                                            <input type="number" className="form-control" id="ForestryRadiata" name="ForestryRadiata" value={rural.ForestryRadiata} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ForestryDouglasFirInput">Forestry: Douglas Fir</label>
                                            <input type="number" className="form-control" id="ForestryDouglasFir" name="ForestryDouglasFir" value={rural.ForestryDouglasFir} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ForestryEucalyptusInput">Forestry: Eucalyptus</label>
                                            <input type="number" className="form-control" id="ForestryEucalyptus" name="ForestryEucalyptus" value={rural.ForestryEucalyptus} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ForestryAcaciaInput">Forestry: Acacia</label>
                                            <input type="number" className="form-control" id="ForestryAcacia" name="ForestryAcacia" value={rural.ForestryAcacia} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="ForestryNativeInput">Forestry: Native</label>
                                            <input type="number" className="form-control" id="ForestryNative" name="ForestryNative" value={rural.ForestryNative} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group" id="CheckboxClass">
                                            <label className="labelClass" htmlFor="ForestryAcaciaInput">Carbon Credits</label>
                                            <Checkbox id="CarbonCredits" name="CarbonCredits" checked={rural.CarbonCredits} onChange={(e) => checkboxHandle(e)}
                                                sx={{
                                                    color: '#563abe',
                                                    '&.Mui-checked': {
                                                        color: '#563abe',
                                                    },
                                                    padding: 0,
                                                }}
                                            />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <label className="labelClass" htmlFor="ForestryAcaciaInput">Contract Management</label>
                                            <Checkbox id="ContractManagement" name="ContractManagement" checked={rural.ContractManagement} onChange={(e) => checkboxHandle(e)}
                                                sx={{
                                                    color: '#563abe',
                                                    '&.Mui-checked': {
                                                        color: '#563abe',
                                                    },
                                                    padding: 0,
                                                }}
                                            />
                                        </div>



                                    </>
                                }
                                {/*Livestock fields*/}
                                {rural.Category === "Livestock" &&
                                    <>
                                        <label className="labelClass"><h5>Livestock fields</h5></label>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockBeefHeifersInput">Livestock: Beef Heifers</label>
                                            <input type="number" className="form-control" id="LivestockBeefHeifers" name="LivestockBeefHeifers" value={rural.LivestockBeefHeifers} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockDiaryHeifers1YearInput">Livestock:Diary Heifers,1 Year</label>
                                            <input type="number" className="form-control" id="LivestockDiaryHeifers1Year" name="LivestockDiaryHeifers1Year" value={rural.LivestockDiaryHeifers1Year} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockDiaryHeifers2YearInput">Livestock:Diary Heifers,2 Year</label>
                                            <input type="number" className="form-control" id="LivestockDiaryHeifers2Year" name="LivestockDiaryHeifers2Year" value={rural.LivestockDiaryHeifers2Year} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockDairyCowsInput">Livestock:Dairy Cows</label>
                                            <input type="number" className="form-control" id="LivestockDairyCows" name="LivestockDairyCows" value={rural.LivestockDairyCows} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockUnitsInput">Stock Units</label>
                                            <input type="number" className="form-control" id="LivestockUnits" name="LivestockUnits" value={rural.LivestockUnits} onChange={(e) => handle(e)}></input>
                                        </div>

                                    </>
                                }
                                {/*Livestock - Finishing fields*/}
                                {rural.Category === "Livestock-Finishing" &&
                                    <>
                                        <label className="labelClass"><h5>Livestock - Finishing fields</h5></label>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockBeefHeifersInput">Livestock:Beef Heifers</label>
                                            <input type="number" className="form-control" id="LivestockBeefHeifers" name="LivestockBeefHeifers" value={rural.LivestockBeefHeifers} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockBeefHeifersInput">Livestock:Diary Heifers,1 Year</label>
                                            <input type="number" className="form-control" id="LivestockDiaryHeifers1Year" name="LivestockDiaryHeifers1Year" value={rural.LivestockDiaryHeifers1Year} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockDiaryHeifers2YearInput">Livestock:Diary Heifers,2 Year</label>
                                            <input type="number" className="form-control" id="LivestockDiaryHeifers2Year" name="LivestockDiaryHeifers2Year" value={rural.LivestockDiaryHeifers2Year} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockDairyCowsInput">Livestock:Dairy Cows</label>
                                            <input type="number" className="form-control" id="LivestockDairyCows" name="LivestockDairyCows" value={rural.LivestockDairyCows} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockUnitsInput">Stock Units</label>
                                            <input type="number" className="form-control" id="LivestockUnits" name="LivestockUnits" value={rural.LivestockUnits} onChange={(e) => handle(e)}></input>
                                        </div>

                                    </>
                                }
                                {/*Livestock - Grazing fields*/}
                                {rural.Category === "Livestock - Grazing" &&
                                    <>
                                        <label className="labelClass"><h5>Livestock - Grazing fields</h5></label>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockBeefHeifersInput">Livestock:Beef Heifers</label>
                                            <input type="number" className="form-control" id="LivestockBeefHeifers" name="LivestockBeefHeifers" value={rural.LivestockBeefHeifers} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockBeefHeifersInput">Livestock:Diary Heifers,1 Year</label>
                                            <input type="number" className="form-control" id="LivestockDiaryHeifers1Year" name="LivestockDiaryHeifers1Year" value={rural.LivestockDiaryHeifers1Year} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockDiaryHeifers2YearInput">Livestock:Diary Heifers,2 Year</label>
                                            <input type="number" className="form-control" id="LivestockDiaryHeifers2Year" name="LivestockDiaryHeifers2Year" value={rural.LivestockDiaryHeifers2Year} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockDairyCowsInput">Livestock:Dairy Cows</label>
                                            <input type="number" className="form-control" id="LivestockDairyCows" name="LivestockDairyCows" value={rural.LivestockDairyCows} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockUnitsInput">Stock Units</label>
                                            <input type="number" className="form-control" id="LivestockUnits" name="LivestockUnits" value={rural.LivestockUnits} onChange={(e) => handle(e)}></input>
                                        </div>
                                    </>
                                }
                                {/*Livestock - Special fields*/}
                                {rural.Category === "Livestock-Special" &&
                                    <>
                                        <label className="labelClass"><h5>Livestock - Special fields</h5></label>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockBeefHeifersInput">Livestock: Beef Heifers</label>
                                            <input type="number" className="form-control" id="LivestockBeefHeifers" name="LivestockBeefHeifers" value={rural.LivestockBeefHeifers} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockBeefHeifersInput">Livestock:Diary Heifers,1 Year</label>
                                            <input type="number" className="form-control" id="LivestockDiaryHeifers1Year" name="LivestockDiaryHeifers1Year" value={rural.LivestockDiaryHeifers1Year} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockDiaryHeifers2YearInput">Livestock:Diary Heifers,2 Year</label>
                                            <input type="number" className="form-control" id="LivestockDiaryHeifers2Year" name="LivestockDiaryHeifers2Year" value={rural.LivestockDiaryHeifers2Year} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockDairyCowsInput">Livestock:Dairy Cows</label>
                                            <input type="number" className="form-control" id="LivestockDairyCows" name="LivestockDairyCows" value={rural.LivestockDairyCows} onChange={(e) => handle(e)}></input>
                                        </div>
                                        <div className="form-group">
                                            <label className="labelClass" htmlFor="LivestockUnitsInput">Stock Units</label>
                                            <input type="number" className="form-control" id="LivestockUnits" name="LivestockUnits" value={rural.LivestockUnits} onChange={(e) => handle(e)}></input>
                                        </div>
                                    </>
                                }
                            </div>
                            <div className="form-group">
                                {/*Additional Information*/}
                                <label className="labelClass"><h5>Additional Information</h5></label>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="SaleMethodInput">Sale Method<span style={{ color: 'red' }}>*</span></label>
                                    <div id="SelectStyle">
                                        <select name="SaleMethod" className="form-control" id="SaleMethod" value={rural.SaleMethod} onChange={(e) => handle(e)} required>
                                            <option className="form-control"></option>
                                            <option className="form-control">P - Private Treaty(Neg.)</option>
                                            <option className="form-control">A - Auction</option>
                                            <option className="form-control">T - Tender</option>
                                        </select>
                                    </div>
                                    {(rural.SaleMethod === "" || rural.SaleMethod === null) &&
                                        <div style={{ color: 'red' }}>{error}</div>
                                        /*<label as="label" className="required" style={{ color: 'red' }}>Sale Method is required</label>*/
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="ListPriceInput">List Price</label>
                                    <div className="input-group">
                                        <span class="input-group-text" id="dollar-sign" >
                                            <i class="bi bi-currency-dollar iconStyles"></i>
                                        </span>
                                        <input type="number" class="form-control" id="ListPrice" value={rural.ListPrice} onChange={(e) => handle(e)} />
                                    </div>
                                    {(rural.SaleMethod === 'P - Private Treaty(Neg.)' && rural.ListPrice === '') &&
                                         <label as="label" className="required" style={{ color: 'red' }}>List Price is required</label>
                                        /*<div style={{ color: 'red' }}>{error}</div>*/
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="SalePriceInput">Sale Price <span style={{ color: 'red' }}>*</span></label>
                                    <div className="input-group">
                                        <span class="input-group-text" id="dollar-sign" >
                                            <i class="bi bi-currency-dollar iconStyles"></i>
                                        </span>
                                        <input type="number" class="form-control" id="SalePrice" value={rural.SalePrice} onChange={(e) => handle(e)} required />
                                    </div>
                                    {(rural.SalePrice === "" || rural.SalePrice === null) &&
                                        <div style={{ color: 'red' }}>{error}</div>
                                        /*<label as="label" className="required" style={{ color: 'red' }}>Sale Price is required</label>*/
                                    }
                                </div>
                                {rural.SalePrice <= (rural.Valuation * 0.1) &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Sale Price is 10% or more below valuation of {rural.Valuation}</label>}
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="ListDateInput">List Date <OverlayTrigger
                                        placement="top" overlay={renderTooltip_listdate}><sup>?</sup></OverlayTrigger><span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input type="date" class="form-control" id="ListDate" value={rural.ListDate} onChange={(e) => handle(e)} required />
                                    {(rural.ListDate === "" || rural.ListDate === null) &&
                                        <div style={{ color: 'red' }}>{error}</div>
                                        /*<label as="label" className="required" style={{ color: 'red' }}>ListDate is required</label>*/
                                    }
                                    {rural.ListDate > rural.AgreementDate &&
                                        <label as="label" className="required" style={{ color: 'red' }}>List Date cannot be greater than Agreement Date</label>
                                    }
                                    {rural.ListDate > rural.UnconditionalDate &&
                                        <label as="label" className="required" style={{ color: 'red' }}>List Date cannot be greater than Unconditional Date</label>
                                    }
                                    {rural.ListDate && rural.AgreementDate &&
                                        listDateObj.getFullYear() + 5 < agreementDateObj.getFullYear() &&
                                        <label as="label" className="required" style={{ color: 'red' }}>List Date is greater than 5 years from Agreement Date</label>
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="AgreementDateInput">Agreement Date <OverlayTrigger
                                        placement="top" overlay={renderTooltip_agreementdate}><sup>?</sup></OverlayTrigger><span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input type="date" class="form-control" id="AgreementDate" value={rural.AgreementDate} onChange={(e) => handle(e)} required />
                                    {(rural.AgreementDate === "" || rural.AgreementDate === null) &&
                                        <div style={{ color: 'red' }}>{error}</div>
                                        /*<label as="label" className="required" style={{ color: 'red' }}>Agreement Date is required</label>*/
                                    }
                                    {rural.AgreementDate > rural.UnconditionalDate &&
                                        <label as="label" className="required" style={{ color: 'red' }}>Agreement Date cannot be greater than Unconditional Date</label>
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="UnconditionalDateInput">Unconditional Date <OverlayTrigger
                                        placement="top" overlay={renderTooltip_unconditionaldate}><sup>?</sup></OverlayTrigger><span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input type="date" class="form-control" id="UnconditionalDate" value={rural.UnconditionalDate} onChange={(e) => handle(e)} required />
                                    {(rural.UnconditionalDate === "" || rural.UnconditionalDate === null) &&
                                        <div style={{ color: 'red' }}>{error}</div>
                                       /* <label as="label" className="required" style={{ color: 'red' }}>Unconditional Date is required</label>*/
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="SettlementDateInput">Settlement Date</label>
                                    <input type="date" class="form-control" id="SettlementDate" value={rural.SettlementDate||''} onChange={(e) => handle(e)} />
                                    {rural.SettlementDate < rural.UnconditionalDate &&
                                        <label as="label" className="required" style={{ color: 'red' }}>Settlement Date cannot be lesser than Unconditional Date</label>
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="ValuationInput">Current Valuation</label>
                                    <div className="input-group">
                                        <span class="input-group-text" id="dollar-sign" >
                                            <i class="bi bi-currency-dollar iconStyles"></i>
                                        </span>
                                        <input type="number" class="form-control" id="Valuation" value={rural.Valuation || ''} onChange={(e) => handle(e)} />
                                    </div>
                                    {(rural.Valuation && rural.LandValue && rural.ValuationImprovement)!==0 && rural.Valuation !== (rural.LandValue + rural.ValuationImprovement) &&
                                        <label as="label" className="required" style={{ color: 'red' }}>Sum of Improvement and Land Value needs to equal Current Valuation</label>
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="ValuationDateInput">Valuation Date</label>
                                    <input type="date" class="form-control" id="ValuationDate" value={rural.ValuationDate||''} onChange={(e) => handle(e)} />
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="LandValueInput">Land Value</label>
                                    <div className="input-group">
                                        <span class="input-group-text" id="dollar-sign" >
                                            <i class="bi bi-currency-dollar iconStyles"></i>
                                        </span>
                                        <input type="number" class="form-control" id="LandValue" value={rural.LandValue} onChange={(e) => handle(e)} />
                                    </div>
                                    {(rural.Valuation && rural.LandValue && rural.ValuationImprovement)!==0 && rural.Valuation !== (rural.LandValue + rural.ValuationImprovement) &&
                                        <label as="label" className="required" style={{ color: 'red' }}>Sum of Improvement and Land Value needs to equal Current Valuation</label>
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="ValuationImprovementInput">Improvement Value</label>
                                    <div className="input-group">
                                        <span class="input-group-text" id="dollar-sign" >
                                            <i class="bi bi-currency-dollar iconStyles"></i>
                                        </span>
                                        <input type="number" class="form-control" id="ValuationImprovement" value={rural.ValuationImprovement} onChange={(e) => handle(e)} />
                                    </div>
                                    {(rural.Valuation && rural.LandValue && rural.ValuationImprovement)!==0 && rural.Valuation !== (rural.LandValue + rural.ValuationImprovement) &&
                                        <label as="label" className="required" style={{ color: 'red' }}>Sum of Improvement and Land Value needs to equal Current Valuation</label>
                                    }
                                </div>
                            </div>
                            <div id="FileReturnButton">
                                <input type="submit" value="Update Return" onClick={SubmitUpdate}
                                    className="btn FileReturnButtonClass" />
                            </div>
                            {/*{message === true && <DisplaySavedMessage />}*/}
                            {message && <div style={{ color: errorMessage ? 'red' : 'green', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>{message}</div>}
                            {validationError && <div style={{ color: errorMessage ? 'red' : 'green', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>{validationError}</div>}
                            {/* Loading overlay */}
                            {loading && (
                                <div className="overlay">
                                    <div className="spinner"></div>
                                    <p style={{ color: 'black', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>Processing... Please wait</p>
                                </div>
                            )}
                        </form>
                    </div>                    
                </>
            }
        </>
    );
}
